import { useAppSelector } from '@store';
import { PermissionEnum } from '@ui/src';
import OngoingMonitoringContent from '../../../components/new-application/common/ongoing-monitoring/ongoing-monitoring';
import useOngoingMonitoring from './hooks/use-ongoing-monitoring';
import { OngoingMonitoringTypes } from './types';

const OngoingMonitoring = ({
  status,
  applicationId,
  ongoingMonitoring,
  ongoingCheckingStatus,
}: OngoingMonitoringTypes) => {
  const { activePermissions } = useAppSelector((state) => state.root);
  const { currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const {
    ongoingIsLoading,
    ongoingIsFetching,
    ongoingStatusIsLoading,
    applyError,
    applyWarningInProgress,
    applyApplicationOngoingWarningAction,
    batchApplyWarningInProgress,
    batchApplyApplicationOngoingWarningAction,
    restartOngoingCheckingAction,
    restartInProgress,
    batchApplyWarningIsSuccess,
    onResetTransactionWarningAction,
    resetTransactionsWarningIsLoading,
    resetTransactionsWarningIsSuccess,
    selectedWarningId,
    getApplicationWarningsAction,
    paginationInProgress,
    paginationIsFetching,
    selectedWarningGroup,
    blacklistData,
    setBlacklistData,
    blacklistDataVisible,
    setBlacklistDataVisible,
    blacklistItem,
    setBlacklistDataItem,
    blacklistItemVisible,
    setBlacklistItemVisible,
    getApplicationOngoingWarningByIdAction,
    isWarningByIdLoading,
    isWarningByIdFetching,
  } = useOngoingMonitoring({
    applicationId,
    ongoingMonitoring,
    currentEmployee,
    status,
    activePermissions,
    ongoingCheckingStatus,
  });

  return (
    <OngoingMonitoringContent
      status={status}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
      isLoading={
        ongoingIsLoading || ongoingIsFetching || ongoingStatusIsLoading
      }
      ongoingMonitoring={ongoingMonitoring}
      isAllowed={activePermissions?.includes(
        PermissionEnum.APPLICATIONS_CUSTOMERS_AML_LIST,
      )}
      applyError={applyError}
      applyWarningInProgress={applyWarningInProgress}
      applyOngoingWarning={applyApplicationOngoingWarningAction}
      batchApplyWarningInProgress={batchApplyWarningInProgress}
      batchApplyOngoingWarning={batchApplyApplicationOngoingWarningAction}
      ongoingCheckingStatus={ongoingCheckingStatus}
      restartOngoingCheckingAction={restartOngoingCheckingAction}
      restartInProgress={restartInProgress}
      batchApplyWarningIsSuccess={batchApplyWarningIsSuccess}
      onResetTransactionWarningAction={onResetTransactionWarningAction}
      resetTransactionsWarningIsLoading={resetTransactionsWarningIsLoading}
      resetTransactionsWarningIsSuccess={resetTransactionsWarningIsSuccess}
      selectedWarningId={selectedWarningId}
      getApplicationWarningsAction={getApplicationWarningsAction}
      paginationInProgress={paginationInProgress || paginationIsFetching}
      selectedWarningGroup={selectedWarningGroup}
      blacklistData={blacklistData}
      setBlacklistData={setBlacklistData}
      blacklistDataVisible={blacklistDataVisible}
      setBlacklistDataVisible={setBlacklistDataVisible}
      blacklistItem={blacklistItem}
      setBlacklistDataItem={setBlacklistDataItem}
      blacklistItemVisible={blacklistItemVisible}
      setBlacklistItemVisible={setBlacklistItemVisible}
      getOngoingWarningById={getApplicationOngoingWarningByIdAction}
      isWarningByIdLoading={isWarningByIdLoading}
      isWarningByIdFetching={isWarningByIdFetching}
    />
  );
};

export default OngoingMonitoring;
